import { render } from "./Fail.vue?vue&type=template&id=668c7064&ts=true"
import script from "./Fail.vue?vue&type=script&lang=ts"
export * from "./Fail.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/tc-admin/tc-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__